import { render, staticRenderFns } from "./HelpProblems.vue?vue&type=template&id=58982d5e&scoped=true&"
import script from "./HelpProblems.vue?vue&type=script&async=true&lang=js&"
export * from "./HelpProblems.vue?vue&type=script&async=true&lang=js&"
import style0 from "./HelpProblems.vue?vue&type=style&index=0&id=58982d5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58982d5e",
  null
  
)

export default component.exports